import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { LoggerService } from '../core/services/logger.service';
import {
    DashboardServicioIntegralFilterDto,
    DashboardServicioIntegralResponseDto,
    DashboardLinerFilterDto,
    DashboardLinerResponseDto,
    DashboardTransporteFilterDto,
    DashboardTransporteResponseDto,
} from '@opb-workspace/shared';

@Injectable({
    providedIn: 'root'
})
export class DashboardService {
    private apiUrl = `${environment.apiUrl}/v1/dashboard`;

    constructor(
        private http: HttpClient,
        private logger: LoggerService
    ) {}

    /**
     * Obtiene los datos del Dashboard de Servicio Integral.
     * @param filters Filtros opcionales (clienteId, temporadaId)
     */
    getServicioIntegral(filters?: DashboardServicioIntegralFilterDto): Observable<DashboardServicioIntegralResponseDto> {
        const filtersStr = filters ? ` con filtros: ${JSON.stringify(filters)}` : '';
        this.logger.info(
            `Obteniendo datos del Dashboard Servicio Integral${filtersStr}`,
            'DashboardService'
        );

        let params = new HttpParams();
        
        if (filters?.clienteId) {
            params = params.set('clienteId', filters.clienteId.toString());
        }
        
        if (filters?.temporadaId) {
            params = params.set('temporadaId', filters.temporadaId.toString());
        }

        return this.http.get<DashboardServicioIntegralResponseDto>(
            `${this.apiUrl}/servicio-integral`,
            { params }
        ).pipe(
            tap((data) => {
                this.logger.info(
                    'Dashboard Servicio Integral obtenido exitosamente',
                    'DashboardService'
                );
            }),
            catchError((error) => {
                this.logger.error(
                    `Error obteniendo Dashboard Servicio Integral: ${error instanceof Error ? error.message : String(error)}`,
                    error as Error,
                    'DashboardService'
                );
                throw error;
            })
        );
    }

    /**
     * Obtiene los datos del Dashboard Liner.
     * @param filters Filtros opcionales (clienteId, temporadaId)
     */
    getLiner(filters?: DashboardLinerFilterDto): Observable<DashboardLinerResponseDto> {
        const filtersStr = filters ? ` con filtros: ${JSON.stringify(filters)}` : '';
        this.logger.info(
            `Obteniendo datos del Dashboard Liner${filtersStr}`,
            'DashboardService'
        );

        let params = new HttpParams();
        
        if (filters?.clienteId) {
            params = params.set('clienteId', filters.clienteId.toString());
        }
        
        if (filters?.temporadaId) {
            params = params.set('temporadaId', filters.temporadaId.toString());
        }

        return this.http.get<DashboardLinerResponseDto>(
            `${this.apiUrl}/liner`,
            { params }
        ).pipe(
            tap((data) => {
                this.logger.info(
                    'Dashboard Liner obtenido exitosamente',
                    'DashboardService'
                );
            }),
            catchError((error) => {
                this.logger.error(
                    `Error obteniendo Dashboard Liner: ${error instanceof Error ? error.message : String(error)}`,
                    error as Error,
                    'DashboardService'
                );
                throw error;
            })
        );
    }

    /**
     * Obtiene los datos del Dashboard Transporte.
     * @param filters Filtros opcionales (clienteId, temporadaId)
     */
    getTransporte(filters?: DashboardTransporteFilterDto): Observable<DashboardTransporteResponseDto> {
        const filtersStr = filters ? ` con filtros: ${JSON.stringify(filters)}` : '';
        this.logger.info(
            `Obteniendo datos del Dashboard Transporte${filtersStr}`,
            'DashboardService'
        );

        let params = new HttpParams();
        
        if (filters?.clienteId) {
            params = params.set('clienteId', filters.clienteId.toString());
        }
        
        if (filters?.temporadaId) {
            params = params.set('temporadaId', filters.temporadaId.toString());
        }

        return this.http.get<DashboardTransporteResponseDto>(
            `${this.apiUrl}/transporte`,
            { params }
        ).pipe(
            tap((data) => {
                this.logger.info(
                    'Dashboard Transporte obtenido exitosamente',
                    'DashboardService'
                );
            }),
            catchError((error) => {
                this.logger.error(
                    `Error obteniendo Dashboard Transporte: ${error instanceof Error ? error.message : String(error)}`,
                    error as Error,
                    'DashboardService'
                );
                throw error;
            })
        );
    }
}
